module.exports = {
  A: " #FF83FA",
  C: " #40E0D0",
  G: " #FF83FA",
  R: " #FF83FA",
  T: " #40E0D0",
  U: " #40E0D0",
  Y: " #40E0D0"
};



//////////////////
// WEBPACK FOOTER
// ./~/msa-colorschemes/src/purine.js
// module id = 128
// module chunks = 0